import idx from 'idx';
import { debounce } from 'lodash';
import {
  clearRoute,
  getServiceUnavailableData,
  setRoute,
} from 'singletons/serviceUnavailableCache';
import ToastActions from 'actions/ToastActions';

const DEFAULT_503_MESSAGE = 'We are currently experiencing some technical issues. Try again later.';

export const display503ErrorToast = debounce(
  (message: string) => {
    ToastActions.showErrorToast(message);
  },
  1000,
  { leading: true }
);

export function setServiceUnavailable(response: any, endpoint: string) {
  const retryAfterSeconds = idx(response.headers, (_) => _['retry-after']);
  if (retryAfterSeconds) {
    const message = idx(response.body, (_) => _.message) || DEFAULT_503_MESSAGE;
    const expirationTime = Date.now() + parseInt(retryAfterSeconds, 10);

    display503ErrorToast(message);
    setRoute(endpoint, expirationTime, message);
  }
}

export function serviceUnavailable(endpoint: string): boolean {
  const unavailableData = getServiceUnavailableData(endpoint);
  if (!unavailableData) {
    return false; // no cached 503s found
  }

  const retryLaterExpired = Date.now() > unavailableData.expirationTime;
  if (retryLaterExpired) {
    clearRoute(endpoint);
    return false;
  }

  display503ErrorToast(unavailableData.message);

  return true;
}
